<template xmlns="">
  <div class="pc_container">
    <div style=" position: absolute;top: 0;right: 10px;">v.{{versionNum}} {{httpType}}  </div>
    <div v-if="(error != null) && (error != '')">
      {{error}}
    </div>
    <div v-else>

      <!-- 電子 -->
      <div class="hello" v-if="esports">
        <div class="title">
          {{ $t(`lang.str_gameresult`) }}
        </div>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_gameid`) }}</div>
              <div>{{ $t(showCustomName(gameid, merchantName)) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_recordid`) }}</div>
              <div>{{ recordId }}</div>
            </div>
          </el-col>
          <el-col v-if="withoutUser != 1" :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_username`) }}</div>
              <div>{{ username }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_bet`) }}</div>
              <div>{{ parseFloat(betamount).toFixed(3) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_win`) }}</div>
              <div>{{ parseFloat(profit).toFixed(3) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="hasfree">
            <div class="item">
              <div>{{ $t(`lang.str_isfree`) }}</div>
              <div>{{ isfree }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="hasext">
            <div class="item">
              <div>{{ $t(`lang.str_ext`) }}</div>
              <div>{{ ext }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="hasbonuswin">
            <div class="item">
              <div>{{ $t(`lang.str_special`) }}</div>
              <div>{{ bonuswin }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="hasjackpotwin">
            <div class="item">
              <div>{{ $t(`lang.str_jackpot`) }}</div>
              <div>{{ jackpotwin }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="hasextra">
            <div class="item">
              <div>{{ $t(`lang.str_extra`) }}</div>
              <div>{{ extra ? $t(`lang.str_t`) : $t(`lang.str_f`) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_starttime`) }}</div>
<!--              <div>{{ timeFormat(betTime) }}</div>-->
              <div>{{ timeFormat(startTime) }}</div>
            </div>
          </el-col>
        </el-row>

        <!-- 福神報喜 -->
        <div v-if="gameid == 100" class="gamebox">
          <SlotsBonusLayout game-path="fu_shen" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :show-top = true
            :game-path="getGameRes(isfree,'普通','fu_shen','fu_shenfree')"/>
            <div style="display:flex;width:100%;padding:20px;padding-top:0;">
              <div v-for="(arr, index) in getarr" :key="index" style="width:100px;text-align: center;">
                {{ arr }}
              </div>
              <div>
                {{total}}
              </div>
            </div>
          <SlotsWinTotalLayout :show-total=true :win-value-total="winValueTotal"></SlotsWinTotalLayout>
        </div>
        <!-- 發發發2 -->
        <div v-if="gameid == 101" class="gamebox">
          <SlotsBonusLayout game-path="fafafa" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :show-top= true
            :lang="getlang"
            linesId = "0"
            game-path="fafafa"/>

          <div v-if="isHasTwo">
            <slotsDetailLayout
              :mapList ="mapListTwo"
              :mapListDetail ="mapListDetailTwo"
              :mapIndex="mapIndexTwo"
              :lang="lang"
              linesId="1"
              gamePath="fafafa" />
          </div>
          <SlotsWinTotalLayout
            :show-total = true
            :win-value-total="winValueTotal">
          </SlotsWinTotalLayout>
        </div>
        <!-- 決戰三國 -->
        <div v-if="gameid == 102" class="gamebox">
          <SlotsBonusLayout game-path="jzsg" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :show-top= true
            :show-total=true
            :winValueTotal = "winValueTotal"
            linesId = "0"
            game-path="jzsg"/>
        </div>
        <!-- 德古拉夫人 -->
        <div v-if="gameid == 103" class="gamebox">
          <SlotsBonusLayout game-path="dglfr" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            linesId = "0"
            :show-top= true
            :show-total=true
            :winValueTotal = "winValueTotal"
            game-path="dglfr"/>
        </div>
        <!-- 埃及寶藏 -->
        <div v-if="gameid == 104" class="gamebox">
          <SlotsBonusLayout game-path="ajbz" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            linesId = "0"
            :show-top= true
            :show-total=true
            :winValueTotal = "winValueTotal"
            game-path="ajbz"/>
        </div>
        <!-- 東海龍王 -->
        <div v-if="gameid == 300" class="gamebox">
          <SlotsBonusLayout game-path="dhlw" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top= true
            :show-total=true
            game-path="dhlw"/>
        </div>
        <!-- 龍虎爭霸 -->
        <div v-if="gameid == 301" class="gamebox">
          <SlotsBonusLayout game-path="lhzb" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top= true
            :show-total=true
            game-path="lhzb"/>
        </div>
        <!-- 雷霆宙斯 -->
        <div v-if="gameid == 302" class="gamebox">
          <SlotsBonusLayout game-path="zeus" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top= true
            :show-total=true
            game-path="zeus"/>
        </div>
        <!-- 撒哈拉之夜 -->
        <div v-if="gameid == 303" class="gamebox">
          <SlotsBonusLayout game-path="shlzy" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top= true
            :show-total=true
            game-path="shlzy"/>
        </div>
        <!-- 澤達的財富 -->
        <div v-if="gameid == 304" class="gamebox">
          <SlotsBonusLayout game-path="zddcf" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top= true
            :show-total=true
            game-path="zddcf"/>
        </div>
        <!-- 五龙争霸 -->
        <div v-if="gameid == 305" class="gamebox">

          <game305 :mapListDetail ="mapListDetail"
                    :mapIndex="mapIndex"
                    :lang="getlang"
                    :wildType="wildtype"
                    :wildMul="wildmul"
                    :show-total= true
                    :show-top= true
                    :winValueTotal="winValueTotal"
                    :mapList="mapList" />
        </div>

        <!-- 神圣吸血鬼 -->
        <div v-if="gameid == 5000" class="gamebox">
          <SlotsBonusLayout game-path="ssxxg" :bonus_id = "bonus_id"/>
          <SlotsMapTwoLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :checkFreeColor = true
            :show-top = true
            :show-total=true
            freeId = "S"
            game-path="ssxxg"/>
        </div>
        <!-- 拳皇 -->
        <div v-if="gameid == 5001" class="gamebox">
          <SlotsBonusLayout game-path="qh" :bonus_id = "bonus_id"/>
          <SlotsMapTwoLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :checkFreeColor = true
            freeId = "S"
            :show-top= true
            :show-total=true
            game-path="qh"/>
        </div>
        <!-- 麻将胡了 -->
        <div v-if="gameid == 5002" class="gamebox">
          <SlotsBonusLayout game-path="mjhl" :bonus_id = "bonus_id"/>
          <SlotsMapTwoLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :checkFreeColor = true
            freeId = "S"
            :sumRows = 4
            :show-top= true
            :show-total=true
            game-path="mjhl"/>
        </div>
        <!-- 麻将胡了 2 -->
        <div v-if="gameid == 5014" class="gamebox">
          <SlotsMapTwoLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            img-area-class-id="H"
            freeId = "S"
            :checkFreeColor = true
            :sumRows = 4
            :show-top=true
            :show-total=true
            :is-check-table=true
            :check-table=[4,5,5,5,4]
            :map-top-class=[0,19]
            :mapBottomClass=[3,22]
            game-path="mjhl2"/>
        </div>
        <!-- 超级王牌 -->
        <div v-if="gameid == 5003" class="gamebox">
          <SlotsBonusLayout game-path="SuperAce" :bonus_id = "bonus_id"/>
          <SlotsMapTwoLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :checkFreeColor=true
            :sum-rows=4
            :show-top=true
            :show-total=true
            freeId = "S"
            game-path="SuperAce"/>
        </div>
        <!-- 伽罗宝石 -->
        <div v-if="gameid == 5004" class="gamebox">
          <SlotsBonusLayout game-path="jlbs" :bonus_id = "bonus_id"/>
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :show-top=true
            imgAreaClassId="4"
            :show-total=true
            game-path="jlbs"/>
        </div>
        <!-- 黄金之书 -->
        <div v-if="gameid == 5005" class="gamebox">
          <game5005
            :mapList="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :subMapList ="subMapList"
            :subMapListDetail ="subMapListDetail"
            :subMapIndex="subMapIndex"
            :lang="getlang"
            :winValueTotal = "winValueTotal"
            :isFree= "isfree"
            :extra= "extra"
            :symbol1= "symbol1"
            :symbol2= "symbol2"
          />
        </div>
        <!-- 龙龙龙 -->
        <div v-if="gameid == 5006" class="gamebox">
          <game5006
            :show-top=true
            :win-type1 = "winType1"
            :show-total=true
            :winValueTotal="winValueTotal"
            :mapList="mapList" >
          </game5006>
        </div>
        <!-- 庆典之月 -->
        <div v-if="gameid == 5007" class="gamebox">
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            check-scatter-win="true"
            :scatter-win = "scatterwin"
            linesId = "s"
            :isMapsInDetail=true
            :show-top=true
            :show-total=true
            :winValueTotal = "winValueTotal"
            game-path="qdzy"/>

        </div>
        <!-- 美杜莎 -->
        <div v-if="gameid == 5015" class="gamebox">
          <Game5015
            :mapList="mapList"
            :lang="getlang"
            :wins="wins"
            :Phone="isPhone"
            :isFree="isFree">
          </Game5015>
        </div>
        <!-- 牛仔对决 -->
        <div v-if="gameid == 5016" class="gamebox">
          <Game5016 :mapList="mapList" :lang="getlang" :wins="wins" :Phone="isPhone"></Game5016>
        </div>
        <!-- 雷神X -->
        <div v-if="gameid == 5012" class="gamebox">
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            check-scatter-win="true"
            :scatter-win = "bonuswin"
            scatterItem = "B"
            linesId = "s"
            :isMapsInDetail=true
            :show-top=true
            :show-total=true
            :winValueTotal = "winValueTotal"
            game-path="leishenx"/>
        </div>
        <!-- 魔兽世界 -->
        <div v-if="gameid == 5013" class="gamebox">
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :check-scatter-win=true
            :scatter-win = "scatterwin"
            scatterItem = "S"
            linesId = "s"
            :isMapsInDetail=true
            :show-top=true
            :show-total=true
            :winValueTotal = "winValueTotal"
            game-path="mssj"/>
        </div>
        <!-- 森巴嘉年华 -->
        <div v-if="gameid == 5008" class="gamebox">
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :check-scatter-win=true
            :scatter-win = "scatterwin"
            scatterItem = "SCAT"
            linesId = "s"
            isMapsInDetail="true"
            :show-top = true
            :show-total= true
            :winValueTotal = "winValueTotal"
            game-path="simba"/>
        </div>
        <!-- 777 -->
        <div v-if="gameid == 5009" class="gamebox">
          <game5009
                    :lang="getlang"
                    :show-total=true
                    :show-top= true
                    :winType1 ="winType1"
                    :winType2 = "winType2"
                    :winValueTotal="winValueTotal"
                    :mapList="mapList" />
        </div>
        <!-- 美食专家 -->
        <div v-if="gameid == 5010" class="gamebox">
          <slotsMapLayout
            :mapList ="mapList"
            :mapListDetail ="mapListDetail"
            :mapIndex="mapIndex"
            :lang="getlang"
            :check-scatter-win=true
            :scatter-win = "scatterwin"
            scatterItem = "S"
            linesId = "s"
            isMapsInDetail="true"
            :show-top = true
            :show-total= true
            :winValueTotal = "winValueTotal"
            game-path="mszj"/>
        </div>
        <!-- 赏金猎人 -->
        <div v-if="gameid == 5011" class="gamebox">
          <game5011 :show-top=true
                    :mapListDetail ="mapListDetail"
                    :mapIndex="mapIndex"
                    :lang="getlang"
                    :show-total=true
                    linesId = "s"
                    :winValueTotal="winValueTotal"
                    :mapList="mapList" >

          </game5011>
        </div>
        <!-- 哈希 -->
        <div v-if="gameid == 6000 || gameid == 6001 || gameid == 6002" class="gamebox">
          <div class="top">
            <div class="gametitle">
              {{ $t(`lang.str_detail`) }}
            </div>
            <div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashblock`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div>{{ hashblock_l }}<span style="color: red;">{{ hashblock_v }}</span>{{ hashblock_r }}</div>
                </div>
              </div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashheight`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div>{{ hashheight  }}</div>
                </div>
              </div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashbettime`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div>{{ timeFormat(hashbettime)  }}</div>
                </div>
              </div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashresulttime`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div>{{ timeFormat(hashresulttime)  }}</div>
                </div>
              </div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashbettype`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div>{{ hashbettype  }}</div>
                </div>
              </div>
              <div style="display:flex;justify-content: space-between; padding:8px;font-size:14px;">
                <div style="width:10%">
                  {{ $t(`lang.str_hashresult`) }}
                </div>
                <div style="width:90%;word-break: break-all; color: green;">
                  <div v-html="hashresult"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 捕魚 -->
      <div class="hello" v-if="fish">
        <div class="title">
          {{ $t(`lang.str_gameresult`) }}
        </div>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_gameid`) }}</div>
              <div>{{ $t(showCustomName(gameid, merchantName)) }}</div>

            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="is_props">
            <div class="item">
              <div>{{ $t(`lang.str_props`) }}</div>
              <div>{{ $t(`lang.str_props_type_` + props_type) }} - {{ $t(`lang.str_props_level_` + props_level) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_recordid`) }}</div>
              <div>{{ recordId }}</div>
            </div>
          </el-col>

          <el-col v-if="withoutUser != 1" :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_username`) }}</div>
<!--              <div>{{ fishusername }}</div>-->
              <div>{{ username }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_bet`) }}</div>
<!--              <div>{{ parseFloat(fishbet).toFixed(2) }}</div>-->
              <div>{{ parseFloat(betamount).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_win`) }}</div>
<!--              <div>{{ (fishwin - fishbet).toFixed(2) }}</div>-->
              <div>{{ parseFloat(profit).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_starttime`) }}</div>
<!--              <div>{{ timeFormat(startTime) }}</div>-->
              <div>{{ timeFormat(startTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_endtime`) }}</div>
<!--              <div>{{ timeFormat(endTime) }}</div>-->
              <div>{{ timeFormat(endTime) }}</div>
            </div>
          </el-col>
        </el-row>
        <!-- 飞龙捕鱼 -->
        <div class="gameImgAreafish" v-if="gameid == 1000">
          <div style="border-top:1px solid #EBEEF5;">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <div v-if="is_props" style="display: flex; flex-direction: row; flex-wrap:wrap;">
              <div v-for="(item, index) in fishList" :key="index">
                <div v-if="(item >= 2000) && (item < 2200)">
                  <div v-if="index == 0" :style="{
                      width: 100 + 'px', margin: '10px', position: 'relative'
                      , background: ((Math.floor(item / 100) == 18) || (Math.floor(item / 100) == 46) || (Math.floor(item / 100) == 47) || (Math.floor(item / 100) == 48))
                      ? `url(${require('../assets/fish/piece/gold_fish_bg.png')})`
                      : `url(${require('../assets/fish/piece/normal_fish_bg.png')})`
                      , 'background-size': '100% 100%'
                    }">
                    <img :src="require('../assets/fish/piece/piece_' + item + '.png')" alt=""
                      style="width:100px;"/>
                  </div>
                </div>
                <div v-else :style="{
                    width: 100 + 'px', margin: '10px', position: 'relative'
                    , background: ((Math.floor(item / 100) == 18) || (Math.floor(item / 100) == 46) || (Math.floor(item / 100) == 47) || (Math.floor(item / 100) == 48))
                    ? `url(${require('../assets/fish/piece/gold_fish_bg.png')})`
                    : `url(${require('../assets/fish/piece/normal_fish_bg.png')})`
                    , 'background-size': '100% 100%'
                  }">
                  <img :src="require('../assets/fish/flydragonfish/fish' + Math.floor(item / 100) + '.png')" alt=""
                    style="width:100px;" />

                  <img :src="require('../assets/fish/piece/piece_level' + (Math.floor(item % 100) % 3) + '.png')" alt=""
                      style="width:20px; position: absolute; top: -5px; right: -5px">
                </div>
              </div>
            </div>
            <div v-else>
              <el-table :data="fishList" border :summary-method="getSummaries" show-summary
                :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
                <el-table-column prop="HitFishs" label="名称" min-width="60%">
                  <template slot-scope="scope">
                    <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                      <div v-if="scope.row.DropBonus != null && scope.row.DropBonus.length > 0" style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                        <div v-for="(item, index) in fishMerge(scope.row.DropBonus)" :key="index" :style="{
                            width: 100 + 'px', margin: '10px', position: 'relative' }">
<!--                          x{{layout.count}}-->
                          <div><span class="fish_odd">{{fishOdd(gameid,item.type)}}</span> x{{item.count}}</div>
                          <div :style="{
                            width: 100 + 'px', background: ((Math.floor(item.type / 100) == 18) || (Math.floor(item.type / 100) == 46) || (Math.floor(item.type / 100) == 47) || (Math.floor(item.type / 100) == 48))
                            ? `url(${require('../assets/fish/piece/gold_fish_bg.png')})`
                            : `url(${require('../assets/fish/piece/normal_fish_bg.png')})`
                            , 'background-size': '100% 100%'
                          }">

                            <div v-if="(item.type >= 2000) && (item.type < 2200)">
                              <img :src="require('../assets/fish/piece/piece_' + item.type + '.png')" alt=""
                                style="width:100px;"/>
                            </div>
                            <div v-else>
                              <img :src="require('../assets/fish/flydragonfish/fish' + Math.floor(item.type / 100) + '.png')" alt=""
                                style="width:100px;" />
                              <img :src="require('../assets/fish/piece/piece_level' + (Math.floor(item.type % 100) % 3) + '.png')" alt=""
                                  style="width:20px; position: absolute; top: 15px; right: -5px">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                        <div v-for="(item, index) in fishMerge(scope.row.HitFishs)" :key="index" :style="{width: 100 + 'px', margin: '10px', position: 'relative'}">
<!--                          x{{layout.count}}-->
                          <div><span class="fish_odd">{{fishOdd(gameid,item.type)}}</span> x{{item.count}}</div>
                          <div :style="{ width: 100 + 'px' }">
                            <div>
                              <img :src="require('../assets/fish/flydragonfish/fish' + item.type + '.png')" alt=""
                                style="width:100px;">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="BetAmount" label="投注" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.Type || scope.row.Type == 0" style="text-align: left;">
<!--                      {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                    </div>
                    <div v-else style="text-align: left;">
                      {{$t("lang.fishbettype_" + scope.row.Type)}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="WinAmount" label="贏分" min-width="20%">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="Energy" label="" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="scope.row.Energy">能量炮</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 星空捕魚 -->
        <div class="gameImgAreafish" v-if="gameid == 1001">
          <div style="border-top:1px solid #EBEEF5">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <el-table :data="fishList" border :summary-method="getSummaries" show-summary
              :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
              <el-table-column prop="HitFishs" label="名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.HitFishs.length > 1">
                    <div v-for="(item, index) in scope.row.HitFishs" :key="index">
                      <div><span class="fish_odd">{{fishOdd(gameid,item)}}</span> x 1</div>
                      <img :src="require('../assets/fish/starfish/fish' + item + '.png')" alt="" style="width:100px;">
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="scope.row.HitFishs.length > 0"><span class="fish_odd">{{fishOdd(gameid,scope.row.HitFishs[0])}}</span> x 1 </div>
                    <img :src="require('../assets/fish/starfish/fish' + scope.row.HitFishs + '.png')" alt=""
                      style="width:100px;">
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="BetAmount" label="投注">
                <template slot-scope="scope">
<!--                  {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                </template>
              </el-table-column>
              <el-table-column prop="WinAmount" label="贏分">
                <template slot-scope="scope">
                  {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 經典捕魚 -->
        <div class="gameImgAreafish" v-if="gameid == 1002">
          <div style="border-top:1px solid #EBEEF5">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <el-table :data="fishList" border :summary-method="getSummaries" show-summary
              :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
              <el-table-column prop="HitFishs" label="名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.HitFishs.length > 1">
                    <div v-for="(item, index) in scope.row.HitFishs" :key="index">
                      <div><span class="fish_odd">{{fishOdd(gameid,item)}}</span> x 1 </div>
                      <img :src="require('../assets/fish/jingdianfish/fish' + item + '.png')" alt="" style="width:100px;">
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="scope.row.HitFishs.length > 0"><span class="fish_odd">{{fishOdd(gameid,scope.row.HitFishs[0])}}</span> x 1 </div>
                    <img :src="require('../assets/fish/jingdianfish/fish' + scope.row.HitFishs + '.png')" alt=""
                      style="width:100px;">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="BetAmount" label="投注">
                <template slot-scope="scope">
<!--                  {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                </template>
              </el-table-column>
              <el-table-column prop="WinAmount" label="赢分">
                <template slot-scope="scope">
                  {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                </template>
              </el-table-column>
              <el-table-column prop="Energy" label="">
                <template slot-scope="scope">
                  <div v-if="scope.row.Energy">能量炮</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 復古捕魚 -->
        <div class="gameImgAreafish" v-if="gameid == 1003">
          <div style="border-top:1px solid #EBEEF5">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <el-table :data="fishList" border :summary-method="getSummaries" show-summary
              :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
              <el-table-column prop="HitFishs" label="名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.HitFishs.length > 1">
                    <div v-for="(item, index) in scope.row.HitFishs" :key="index">
                      <div><span class="fish_odd">{{fishOdd(gameid,item)}}</span> x 1 </div>
                      <img :src="require('../assets/fish/fugufish/fish' + item + '.png')" alt="" style="width:100px;">
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="scope.row.HitFishs.length > 0" ><span class="fish_odd">{{fishOdd(gameid,scope.row.HitFishs[0])}}</span> x 1 </div>
                    <img :src="require('../assets/fish/fugufish/fish' + scope.row.HitFishs + '.png')" alt=""
                      style="width:100px;">
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="BetAmount" label="投注">
                <template slot-scope="scope">
<!--                  {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                </template>
              </el-table-column>
              <el-table-column prop="WinAmount" label="赢分">
                <template slot-scope="scope">
                  {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                </template>
              </el-table-column>
              <el-table-column prop="Energy" label="">
                <template slot-scope="scope">
                  <div v-if="scope.row.Energy">能量炮</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 街機捕魚 -->
        <div class="gameImgAreafish" v-if="gameid == 1004">
          <div style="border-top:1px solid #EBEEF5">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <el-table :data="fishList" border :summary-method="getSummaries" show-summary
              :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
              <el-table-column prop="HitFishs" label="名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.HitFishs">
                    <div v-if="scope.row.HitFishs.length > 1">
                      <div v-for="(item, index) in scope.row.HitFishs" :key="index">
                        <div><span class="fish_odd">{{fishOdd(gameid,item)}}</span> x 1 </div>
                        <img :src="require('../assets/fish/jiejifish/fish' + item + '.png')" alt="" style="width:100px;">
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.HitFishs.length > 0" ><span class="fish_odd">{{fishOdd(gameid,scope.row.HitFishs[0])}}</span> x 1 </div>
                      <img :src="require('../assets/fish/jiejifish/fish' + scope.row.HitFishs + '.png')" alt=""
                        style="width:100px;">
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="BetAmount" label="投注">
                <template slot-scope="scope">
<!--                  {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                </template>
              </el-table-column>
              <el-table-column prop="WinAmount" label="赢分">
                <template slot-scope="scope">
                  {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                </template>
              </el-table-column>
              <el-table-column prop="Energy" label="">
                <template slot-scope="scope">
                  <div v-if="scope.row.Energy">能量炮</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 创世捕魚 -->
        <div class="gameImgAreafish" v-if="gameid == 1005">
          <div style="border-top:1px solid #EBEEF5">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <el-table :data="fishList" border :summary-method="getSummaries" show-summary
              :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
              <el-table-column prop="HitFishs" label="名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.HitFishs">
                    <div v-if="scope.row.HitFishs.length > 1">
                      <div v-for="(item, index) in scope.row.HitFishs" :key="index">
                        <div><span class="fish_odd">{{fishOdd(gameid,item)}}</span> x 1 </div>
                        <img :src="require('../assets/fish/csfish/' + item + '.png')" alt="" style="width:100px;">
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.HitFishs.length > 0"><span class="fish_odd">{{fishOdd(gameid,scope.row.HitFishs[0])}}</span> x 1 </div>
                      <img :src="require('../assets/fish/csfish/' + scope.row.HitFishs + '.png')" alt=""
                        style="width:100px;">
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="BetAmount" label="投注">
                <template slot-scope="scope">
<!--                  {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                      <div v-if = "scope.row.WinAmount > 0">
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                      </div>
                      <div v-else>
                        {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                      </div>
                </template>
              </el-table-column>
              <el-table-column prop="WinAmount" label="赢分">
                <template slot-scope="scope">
                  {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                </template>
              </el-table-column>
              <el-table-column prop="Energy" label="">
                <template slot-scope="scope">
                  <div v-if="scope.row.Energy">能量炮</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 李逵劈鱼 -->
        <div class="gameImgAreafish" v-if="gameid == 1006">
          <div style="border-top:1px solid #EBEEF5;">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <div v-if="boxItem">
              <div style="display:flex;justify-content: space-between; text-align: center;padding:8px;">
                <el-table :data="[{ 'id': Math.ceil((boxItemId + 1) / 5), 'bet': 0, 'win': boxItemWin }]" :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
                  <el-table-column label="名称" prop="id" min-width="60%">
                    <template slot-scope="scope">
                    <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                      <div :style="{width: 100 + 'px', margin: '10px', position: 'relative'}">
                        <div :style="{ width: 100 + 'px' }">
                          <div>
                           <img :src="require('../assets/fish/lkpy/box' + scope.row.id + '.png')" alt=""
                              style="width:100px;" />
                          </div>
                        </div>
                      </div>
                    </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="投注" prop="bet" min-width="20%">
                    <template slot-scope="scope">
                    -
                    </template>
                  </el-table-column>
                  <el-table-column label="贏分" prop="win" min-width="20%">
                    <template slot-scope="scope">
                    {{parseFloat(scope.row.win).toFixed(2) / 100}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Energy" label="" min-width="20%">
                    <template slot-scope="scope">
                      <div v-if="scope.row.Energy">能量炮</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-else>
              <el-table :data="fishList" border :summary-method="getSummaries" show-summary
                :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
                <el-table-column prop="HitFishs" label="名称" min-width="60%">
                  <template slot-scope="scope">
                      <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                        <div v-for="(item, index) in fishMerge(scope.row.HitFishs)" :key="index" :style="{width: 100 + 'px', margin: '10px', position: 'relative'}">
<!--                          x{{layout.count}}-->
                          <div><span class="fish_odd">{{fishOdd(gameid,item.type)}}</span> x {{item.count}}</div>
                          <div :style="{ width: 100 + 'px' }">
                            <div>
                             <img :src="require('../assets/fish/lkpy/' + String(item.type).padStart(3, '0') + '.png')" alt=""
                                style="width:100px;" />
                            </div>
                          </div>
                        </div>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column prop="BetAmount" label="投注" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.Type || scope.row.Type == 0" style="text-align: left;">
<!--                      {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                          <div v-if = "scope.row.WinAmount > 0">
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                          </div>
                          <div v-else>
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                          </div>
                    </div>
                    <div v-else style="text-align: left;">
                      {{$t("lang.fishbettype_" + scope.row.Type)}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="WinAmount" label="贏分" min-width="20%">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="Energy" label="" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="scope.row.Energy">能量炮</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 摇钱树 -->
        <div class="gameImgAreafish" v-if="gameid == 1007">
          <div style="border-top:1px solid #EBEEF5;">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <div>
              <el-table :data="fishList" border :summary-method="getSummaries" show-summary
                :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
                <el-table-column prop="HitFishs" label="名称" min-width="60%">
                  <template slot-scope="scope">
                      <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;">
                        <div v-for="(item, index) in fishMerge(scope.row.HitFishs)" :key="index" :style="{width: 100 + 'px', margin: '10px', position: 'relative'}">
<!--                          x{{layout.count}}-->
                          <div><span class="fish_odd">{{fishOdd(gameid,item.type)}}</span> x{{item.count}}</div>
                          <div :style="{ width: 100 + 'px' }">
                            <div>
                             <img :src="require('../assets/fish/yqs/' + String(item.type).padStart(3, '0') + '.png')" alt=""
                                style="width:100px;" />
                            </div>
                          </div>
                        </div>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column prop="BetAmount" label="投注" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.Type || scope.row.Type == 0" style="text-align: left;">
<!--                      {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                          <div v-if = "scope.row.WinAmount > 0">
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                          </div>
                          <div v-else>
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                          </div>
                    </div>
                    <div v-else style="text-align: left;">
                      {{$t("lang.fishbettype_" + scope.row.Type)}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="WinAmount" label="贏分" min-width="20%">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="Energy" label="" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="scope.row.Energy">能量炮</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 福神捕鱼 -->
        <div class="gameImgAreafish" v-if="gameid == 1008">
          <div style="border-top:1px solid #EBEEF5;">
            <div class="top">
              <div class="gametitle">{{ $t(`lang.str_detail`) }}</div>
            </div>
            <div>
               <el-table :data="boxItem ? fishList : [{'HitFishs': [ ], 'Type': 0, 'BetAmount': betamount * 100, 'WinAmount': win * 100}]" border :summary-method="getSummaries" show-summary
                :header-cell-style="{ background: '#e9e9e9', color: '#606266', fontWeight: '700', height: '54px', fontSize: '14px' }">
                <el-table-column prop="HitFishs" label="名称" min-width="60%">
                  <template slot-scope="scope">
                      <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;" v-if="boxItem">
                        <div v-for="(item, index) in fishMerge(scope.row.HitFishs)" :key="index" :style="{width: 100 + 'px', margin: '10px', position: 'relative'}">
<!--                          x{{layout.count}}-->
                          <div><span class="fish_odd">{{fishOdd(gameid,item.type)}}</span> x {{item.count}}</div>
                          <div :style="{ width: 100 + 'px' }">
                            <div>
                             <img :src="require('../assets/fish/fushen/' + String(item.type).padStart(3, '0') + '.png')" alt=""
                                style="width:100px;" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="width: auto; display: flex; flex-direction: row; flex-wrap:wrap;" v-else>
                          <div :style="{ width: 100 + 'px' }">
                            <div>
                             <img :src="require('../assets/fish/fushen/box1.png')" alt=""
                                style="width:100px;" />
                            </div>
                          </div>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column prop="BetAmount" label="投注" min-width="20%">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.Type || scope.row.Type == 0" style="text-align: left;">
<!--                      {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}-->
                          <div v-if = "scope.row.WinAmount > 0">
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}<span class="fish_odd"> (x{{ scope.row.WinAmount/scope.row.BetAmount }})</span>
                          </div>
                          <div v-else>
                            {{ parseFloat(scope.row.BetAmount).toFixed(2) / 100 }}
                          </div>
                    </div>
                    <div v-else style="text-align: left;">
                      {{$t("lang.fishbettype_" + scope.row.Type)}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="WinAmount" label="贏分" min-width="20%">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.WinAmount).toFixed(2) / 100 }}
                  </template>
                </el-table-column>
                 <el-table-column prop="Energy" label="" min-width="20%">
                   <template slot-scope="scope">
                     <div v-if="scope.row.Energy">巨福炮</div>
                   </template>
                 </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

      </div>

      <!-- 扑克 -->
      <div class="hello" v-if="joker">
        <div class="title">
          {{ $t(`lang.str_gameresult`) }}
        </div>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_gameid`) }}</div>
              <div>{{ $t(showCustomName(gameid, merchantName)) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_recordid`) }}</div>
              <div>{{ recordId }}</div>
            </div>
          </el-col>
          <el-col v-if="withoutUser != 1" :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_username`) }}</div>
              <div>{{ username }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_bet`) }}</div>
              <div>{{ parseFloat(betamount).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_win`) }}</div>
              <div>{{ parseFloat(profit).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_starttime`) }}</div>
<!--              <div>{{ timeFormat(betTime) }}</div>-->
              <div>{{ timeFormat(startTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_endtime`) }}</div>
              <div>{{ timeFormat(endTime) }}</div>
            </div>
          </el-col>
        </el-row>

        <div v-if="gameid == 2000">
          <Game2000
            :winValueTip = "winValueTip"
            :winValueTotal="winValueTotal"
            :isTotalWin="isTotalWin"
            :describe_title = "describe_title"
            :describe_content= "describe_content"
            :describe_message="describe_message"
            :common_poker="commonpoker"
            :banker_poker="bankerpoker"
            :hand_poker="handpoker"
            :jokerWin="jokerWin"
            :handlerPokerType="handlerPokerType"
            :bankerPokerType="bankerPokerType"
            :isWinType="iswinType"
            :Antes="Antes"
            :flop="flop"
            :turn="turn"
            :river="river"
            :BonusBet="BonusBet"
            :BonusWin="BonusWin"
            :lang="lang"
            :Phone="isPhone"
          >
          </Game2000>
        </div>
        <div v-if="gameid == 2001">
          <Game2001
            :winValueTip = "winValueTip"
            :winValueTotal="winValueTotal"
            :isTotalWin="isTotalWin"
            :describe_title = "describe_title"
            :describe_content= "describe_content"
            :describe_message="describe_message"
            :bankerpoker="bankerpoker"
            :handlerPokerType="handlerPokerType"
            :bankerPokerType="bankerPokerType"
            :bankerPokerPoint="bankerPokerPoint"
            :seatlist="seatlist"
            :img_lang="img_lang"
            :lang="lang"
            :Phone="isPhone"
          >
          </Game2001>
        </div>
        <div v-if="gameid == 2005">
          <Game2005
            :winValueTip = "winValueTip"
            :winValueTotal="winValueTotal"
            :isTotalWin="isTotalWin"
            :describe_title = "describe_title"
            :describe_content= "describe_content"
            :describe_message="describe_message"
            :gongniu_pokers="gongniu_pokers"
            :niuzai_pokers="niuzai_pokers"
            :common_pokers="common_pokers"
            :gongniu_combine_pokers="gongniu_combine_pokers"
            :niuzai_combine_pokers="niuzai_combine_pokers"
            :gongniuCardType="gongniuCardType"
            :niuzaiCardType="niuzaiCardType"
            :winPos="winPos"
            :detail="detailData"
            :lang="getlang"
            :bets = "bets">
          </Game2005>
        </div>
        <div v-if="gameid == 2002||gameid == 2004">
          <Game20022004
            :winValueTip = "winValueTip"
            :winValueTotal="winValueTotal"
            :isTotalWin="isTotalWin"
            :describe_title = "describe_title"
            :describe_content= "describe_content"
            :describe_message="describe_message"
            :bankerpoker="bankerpoker"
            :bankerPokerPoint="bankerPokerPoint"
            :handlerPokerPoint="handlerPokerPoint"
            :winpos="winpos"
            :bets="bets"
            :handpoker="handpoker"
            :lang="lang"
            :Phone="isPhone">
          </Game20022004>

        </div>
      </div>
      <!-- 火箭 -->
      <div class="hello" v-if="rocket">
        <div class="title">
          {{ $t(`lang.str_gameresult`) }}
        </div>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_recordid`) }}</div>
              <div>{{ recordId }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_gameid`) }}</div>
              <div>{{ $t(showCustomName(gameid, merchantName)) }}</div>
            </div>
          </el-col>
          <el-col v-if="withoutUser != 1" :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_username`) }}</div>
              <div>{{ username }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_win`) }}</div>
              <div>{{ (parachutemoney - betamount).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_starttime`) }}</div>
<!--              <div>{{ timeFormat(betTime) }}</div>-->
              <div>{{ timeFormat(startTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
            <div class="item">
              <div>{{ $t(`lang.str_endtime`) }}</div>
              <div>{{ timeFormat(endTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="gameid == 3200">
            <div class="item">
              <div>{{ $t(`lang.str_3200_currency`) }}</div>
              <div>{{ Currency}}</div>
            </div>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox" v-if="gameid == 3200">
            <div class="item">
              <div>{{ $t(`lang.str_3200_roundId`) }}</div>
              <div>{{ RoundId}}</div>
            </div>
          </el-col>
          <!-- <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
                      <div class="layout">
                          <div>{{ $t(`lang.str_recordid`) }}</div>
                          <div>{{ recordId }}</div>
                      </div>
                  </el-col>
                  <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
                      <div class="layout">
                          <div>{{ $t(`lang.str_bet`) }}</div>
                          <div>{{ parseFloat(betamount) }}</div>
                      </div>
                  </el-col>
                  <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
                      <div class="layout">
                          <div>{{ $t(`lang.str_parachutemoney`) }}</div>
                          <div>{{ parachutemoney }}</div>
                      </div>
                  </el-col>
                  <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="12" class="itemBox">
                      <div class="layout">
                          <div>{{ $t(`lang.str_parachutehigh`) }}</div>
                          <div> {{ parachutehigh }}</div>
                      </div>
                  </el-col> -->
        </el-row>
        <div class="gamebox">
          <div class="top">
            <div class="gametitle">
              {{ $t(`lang.str_detail`) }}
            </div>
          </div>
          <div v-if="gameid == 3000">
           <Game3000
             :winValueTip="winValueTip"
             :winValueTotal="winValueTotal"
             :isTotalWin="isTotalWin"
             :describe_title = "describe_title"
             :describe_content= "describe_content"
             :describe_message="describe_message"
             :betInfos ="betInfos"
             :BombHeight="BombHeight"
             :lang="lang"
             :Phone="isPhone"
           ></Game3000>
          </div>
          <div v-if="gameid == 3001">
            <Game3001
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet_amount ="betamount"
              :balloon_size="balloon_size"
              :balloon_result="balloon_result"
              :lang="lang"
              :Phone="isPhone"
            ></Game3001>
          </div>

          <div v-if="gameid == 3002">
            <Game3002
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet_amount ="betamount"
              :balloon_size="balloon_size"
              :balloon_result="balloon_result"
              :lang="lang"
              :Phone="isPhone">
            </Game3002>
          </div>

          <div v-if="gameid == 3003">
            <Game3003
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet_amount ="betamount"
              :bet_number="bet_number"
              :hit_number="hit_number"
              :odds="odds"
              :lang="lang"
              :Phone="isPhone">
            </Game3003>
          </div>
          <div v-if="gameid == 3004">
            <Game3004
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet_amount ="betamount"
              :mapList="mapList"
              :mapListDetail="mapListDetail"
              :odds="odds"
              :lang="lang"
              :Phone="isPhone">
            </Game3004>
          </div>

          <!--财富滑梯-->
          <div v-if="gameid == 3005" class="gamebox">
            <Game3005
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :tzbs="tzbs"
              :bet="bet"
              :jgbs="jgbs"
              :jg="jg"
              :lang="lang"
              :Phone="isPhone">
            </Game3005>
          </div>

          <!-- 大胃王 -->
          <div v-if="gameid == 3006" class="gamebox">
            <div style="display:flex;justify-content: space-between; text-align: center;padding:8px;">
              <div style="width:10%">
                {{ $t(`lang.str_hashbettype`) }}
              </div>
              <div style="width:90%">
                <div class="gameImgArea"  style="display: flex; flex-direction: row; flex-wrap: wrap;">
                  <div v-for="(itemBase, indexBase) in [[4, 10], [5, 15], [6, 25], [7, 45], [3, 5], [2, 5], [1, 5], [0, 5]]" :key="indexBase" style="width:25%; margin-bottom:10px;">
                    <div v-if="Number(new Map(Object.entries(mapList)).get(itemBase[0].toString())) > 0">
                      <div v-for="(item, index) in mapList" :key="index">
                        <img v-if="itemBase[0] == index" style="height: 50px; width: 50px;" :src="require('../assets/dww/' + index + '.png')" alt="" :class="{ deep: true }">
                        <div v-if="itemBase[0] == index">{{(parseFloat(item).toFixed(2) / 100).toFixed(2)}} x{{itemBase[1]}}</div>
                      </div>
                    </div>
                    <div v-else>
                      <img style="height: 50px; width: 50px;" :src="require('../assets/dww/' + itemBase[0] + '.png')" alt="" :class="{ deep: false }">
                      <div>0 x{{itemBase[1]}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;justify-content: space-between; text-align: center;padding:8px;">
              <div style="width:10%; vertical-align: center;">
                {{ $t(`lang.str_hashresult`) }}
              </div>
              <div style="width:90%">
                <div class="gameImgArea">
                  <div>
                    <img style="height: 50px; width: 50px;" :src="require('../assets/dww/' + winpos + '.png')" alt="" :class="{ deep: true }">
                    {{(parseFloat(geValue).toFixed(2) / 100).toFixed(2)}}
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- 大胃王 -->
          <div v-if="gameid == 3010" class="gamebox">
            <div style="display:flex;justify-content: space-between; text-align: center;padding:8px;">
              <div style="width:10%">
                {{ $t(`lang.str_hashbettype`) }}
              </div>
              <div style="width:90%">
                <div class="gameImgArea"  style="display: flex; flex-direction: row; flex-wrap: wrap;">
                  <div v-for="(itemBase, indexBase) in [[4, 10], [5, 15], [6, 25], [7, 45], [3, 5], [2, 5], [1, 5], [0, 5], [8, 1.25], [9, 4.37]]" :key="indexBase" style="width:25%; margin-bottom:10px;">
                    <div v-if="Number(new Map(Object.entries(mapList)).get(itemBase[0].toString())) > 0">
                      <div v-for="(item, index) in mapList" :key="index">
                        <img v-if="itemBase[0] == index" style="height: 50px; width: 50px;" :src="require('../assets/dww_new/' + index + '.png')" alt="" :class="{ deep: true }">
                        <div v-if="itemBase[0] == index">{{(parseFloat(item).toFixed(2) / 100).toFixed(2)}} x{{itemBase[1]}}</div>
                      </div>
                    </div>
                    <div v-else>
                      <img style="height: 50px; width: 50px;" :src="require('../assets/dww_new/' + itemBase[0] + '.png')" alt="" :class="{ deep: false }">
                      <div>0 x{{itemBase[1]}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;justify-content: space-between; text-align: center;padding:8px;">
              <div style="width:10%; vertical-align: center;">
                {{ $t(`lang.str_hashresult`) }}
              </div>
              <div style="width:90%">
                <div class="gameImgArea">
                  <div>
                    <img style="height: 50px; width: 50px;" :src="require('../assets/dww_new/' + winpos + '.png')" alt="" :class="{ deep: true }">
                    {{(parseFloat(geValue).toFixed(2) / 100).toFixed(2)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 森林舞会 -->
          <div v-if="gameid == 3011" class="gamebox">
            <Game3011
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :winpos="winpos"
              :lang="lang"
              :Phone="isPhone">
            </Game3011>
          </div>
          <!-- 飞禽走兽 -->
          <div v-if="gameid == 3012" class="gamebox">
            <Game3012
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :winpos="winpos"
              :lang="lang"
              :Phone="isPhone">
            </Game3012>
          </div>
          <div v-if="gameid == 3013" class="gamebox">
            <Game3013
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :winpos="winpos" :lang="getlang"
              :Phone="isPhone"
            ></Game3013>
          </div>
          <!--弹弹乐-->
          <div v-if="gameid == 3007" class="gamebox">
            <Game3007
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet="bet"
              :tzfx="tzfx"
              :tzds="tzds"
              :jgbs="jgbs"
              :jg="jg"
              :lang="getlang"
              :Phone="isPhone"
            ></Game3007>
          </div>
          <!--命运转轮-->
          <div v-if="gameid == 3008" class="gamebox">
            <Game3008
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :geValue="geValue"
              :bet="bet"
              :odds="odds"
              :winType="winType"
              :winIndex="winIndex"
              :winpos="winpos"
              :lang="getlang"
              :Phone="isPhone"
            ></Game3008>
          </div>
          <div v-if="gameid == 3200" class="gamebox">
             <Game3200
               :betInfos ="betInfos"
               :detail="detailData"
               :CrashX = "CrashX"
               :winValueTip="winValueTip"
               :winValueTotal="winValueTotal"
               :isTotalWin="isTotalWin"
               :describe_title = "describe_title"
               :describe_content= "describe_content"
               :describe_message="describe_message"
             ></Game3200>
          </div>
          <div v-if="gameid == 3201" class="gamebox">
            <Game3200
              :betInfos ="betInfos"
              :detail="detailData"
              :CrashX = "CrashX"
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
            ></Game3200>
          </div>
          <!--幸运转轮-->
          <div v-if="gameid == 3009" class="gamebox">
            <Game3009
              :winValueTip="winValueTip"
              :winValueTotal="winValueTotal"
              :isTotalWin="isTotalWin"
              :describe_title = "describe_title"
              :describe_content= "describe_content"
              :describe_message="describe_message"
              :bet="bet"
              :tzfx="tzfx"
              :jgbs="jgbs"
              :tzds="tzds"
              :jg="jg"
              :lang="getlang"
              :Phone="isPhone"
            ></Game3009>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import http from '../http.js'
  import version from '../version.js'

  import {
    slots_utils
  } from "../../untils/slots_utils";
  import {
    comp_name_utils
  } from "../../untils/comp_name_utils";
  import Game3013 from './esports/game_3013.vue';
  import Game5016 from './slots/game_5016.vue';
  import Game5015 from "./slots/game_5015.vue";
  import Game2005 from "./joker/game_2005.vue";
  import Game3200 from './esports/game_3200.vue';

  import {detail_by_token} from "./data/detail_by_token";
  import {detail_by_token_joker} from "./data/detail_by_token_joker";
  import {detail_by_token_rocket} from "./data/detail_by_token_rocket";
  import {detail_by_token_fish} from "./data/detail_by_token_fish";
  import {fish_utils} from "./fish/fish_utils";
  import slots_map_layout from "./slots/layout/slots_map_layout.vue";
  import slots_bonus_layout from "./slots/layout/slots_bonus_layout.vue";
  import slots_detail_layout from "./slots/layout/slots_detail_layout.vue";
  import slots_map_two_layout from "./slots/layout/slots_map_two_layout.vue";
  import {detail_by_token_esports} from "./data/detail_by_token_esports";
  import SlotsMapsDetailLayout from "./slots/layout/slots_maps_detail_layout.vue";
  import SlotsWinTotalLayout from "./slots/layout/slots_win_total_layout.vue";
  import GameTitleLayout from "./common/game_detail_title.vue";
  import Game5005 from "./slots/game_5005.vue";
  import Game5006 from "./slots/game_5006.vue";
  import Game5011 from "./slots/game_5011.vue";
  import Game5009 from "./slots/game_5009.vue";
  import Game305 from "./slots/game_305.vue";
  import DescribeLayout from "./common/describe_layout.vue";
  import Game3000 from "./esports/game_3000.vue";
  import Game3001 from "./esports/game_3001.vue";
  import Game3002 from "./esports/game_3002.vue";
  import Game3003 from "./esports/game_3003.vue";
  import Game3004 from "./esports/game_3004.vue";
  import Game3005 from "./esports/game_3005.vue";
  import Game3011 from "./esports/game_3011.vue";
  import Game3012 from "./esports/game_3012.vue";
  import Game3008 from "./esports/game_3008.vue";
  import Game2000 from "./joker/game_2000.vue";
  import Game2001 from "./joker/game_2001.vue";
  import Game20022004 from "./joker/game_2002_2004.vue";
  import Game3009 from "./esports/game_3009.vue";
  import Game3007 from "./esports/game_3007.vue";

  export default {
    name: 'gameDetail',
    components: {
      Game3007,
      Game3009,
      Game20022004,
      Game2001,
      Game2000,
      Game3008,
      Game3012,
      Game3011,
      Game3005,
      Game3004,
      Game3003,
      Game3002,
      Game3001,
      Game3000,
      DescribeLayout,
      Game305,
      Game3200,
      Game3013,
      Game2005,
      Game5015,
      Game5016,
      Game5005,
      Game5009,
      Game5011,
      Game5006,
      GameTitleLayout,
      SlotsWinTotalLayout,
      SlotsMapsDetailLayout,
      'slotsMapLayout': slots_map_layout,
      'SlotsMapTwoLayout': slots_map_two_layout,
      'SlotsBonusLayout': slots_bonus_layout,
      'slotsDetailLayout': slots_detail_layout,

    },
    data() {
      return {
        esports: false,
        winValueTip: null,
        winValueTotal: null,
        isTotalWin:false,
        tooltip_title:null,
        tooltip_message:null,
        describe_title:null,
        describe_content:null,
        describe_message:null,
        gongniu_pokers:[],
        niuzai_pokers:[],
        common_pokers:[],
        niuzai_combine_pokers:[],
        gongniu_combine_pokers:[],
        winPos:[],
        gongniuCardType:0,
        niuzaiCardType:0,
        CrashX:0,
        Currency:0,
        RoundId:0,
        httpType:http.type,
        versionNum:version.code,
        fish: false,
        joker: false,
        rocket: false,
        result: [

        ],
        total: "",
        geValue: '',
        winIndex: '',
        getarr: '',
        bonuswin: '',
        jackpotwin: '',
        mapIndex: [],
        mapIndexTwo: [],
        subMapIndex: [],
        wins: [],
        isPhone:false,
        mapList: [],
        mapListTwo: [],
        mapListDetail: [],
        mapListDetailTwo: [],
        subMapList: [],
        subMapListDetail: [],
        isHasTwo: false,
        userToken: '', //用户登录token
        recordId: '', //记录 ID
        gameType: '', //1 电子 2 捕鱼
        timestamp: '', //当前记录开始时间戳
        lang: 'zhf',
        getlang: '',
        // 电子
        gameid: '', //游戏id，
        username: '',
        bet: '',
        betamount: '',
        win: '',
        profit: '',
        isfree: '',
        // betTime: '',
        startTime: '',
        endTime: '',
        ext: '',
        hasfree: true,
        hasbonuswin: true,
        hasjackpotwin: false,
        hasext: false,
        hasextra: false,
        //hash
        hashblock: '',
        hashblock_l: '',
        hashblock_v: '',
        hashblock_r: '',
        hashbettime: '',
        hashresulttime: '',
        hashheight: '',
        hashbettype: '',
        hashresult: '',
        // 捕魚
        fishList: [],
        withoutUser:0,
        // gameid: '',
        // recordId: '',
        // username: '',
        // fishbet: '',
        // fishwin: '',
        // startTime: '',
        // endTime: '',
        agentId: '',

        betInfos: [],

        ting: '',
        parachutehigh: '',
        parachutemoney: '',
        balloon_size: '',
        balloon_result: '',
        commonpoker: [],
        bankerpoker: [],
        handpoker: [],
        winpos: [],
        bets: [],
        seatlist: [],
        img_lang: '',
        bankerPokerPoint: '',
        bankerPokerType: '',
        handlerPokerPoint: '',
        handlerPokerType: '',
        iswinType: "",
        Antes: '', //底注
        flop: '', //翻牌
        turn: '', //转牌
        river: '', //河牌
        jokerWin: '',
        BonusBet: '',
        BonusWin: '',
        BombHeight: "",
        rocketList: [],

        detailData:{},

        tzfx: '',
        tzds: '',
        tzbs: '',
        jgbs: '',
        jg: '',

        bet_number: '',
        hit_number: '',
        odds: '',
        winType: '',

        error: null,

        is_props: false,  //飞龙捕鱼合成
        props_level: 0,   //飞龙捕鱼合成等级
        props_type: 0,    //飞龙捕鱼合成类型

        bonus_id: 0,

        extra: false,
        symbol1: null,
        symbol2: null,
        scatterwin: 0,

        wildtype: '',
        wildmul: '',

        boxItem: false,
        boxItemId: 0,
        boxItemWin: 0,

        winType1: 0,
        winType2: 0,

        agentName: "",
        merchantName: "",
      }
    },
    computed: {

    },
    created() {
      //console.log("createds");
      // 先调用 获取url 参数的 连接
      if (window.location.href.indexOf('?') == '-1') {

      } else {
        const getUrlOption = this.GetRequest()
        this.getlang = getUrlOption.lang
        //console.log("1111");
        if ('s' in getUrlOption) {
          this.gameType = getUrlOption.gameType
          this.agentId = getUrlOption.s
        } else {
          if (this.GetRequest()) {
            this.userToken = getUrlOption.token
            this.recordId = getUrlOption.recordId
            this.gameType = getUrlOption.gameType
            this.withoutUser = getUrlOption.withoutUser
            this.timestamp = getUrlOption.timestamp
          }
        }

      }
      if (this.getlang == 'zh_cn') {
        this.$i18n.locale = 'cn'
      } else {
        this.$i18n.locale = 'zhf'
      }
      if (this.agentId != "") {
        this.getDetailBySign()
      } else {
        if (this.gameType == 1 || this.gameType == 7) {
          this.esports = true
          this.getDetailByToken()
        } else if (this.gameType == 2) {
          this.fish = true
          this.getDetailByTokenFish()
        } else if (this.gameType == 6) {
          this.joker = true
          this.getDetailByTokenJoker()
        } else if (this.gameType == 5) {
          this.rocket = true
          this.getDetailByTokenrocket()
        }
      }


    },
    mounted() {


    },
    methods: {
      fishMerge(fishlist) {
        const mergedArray = Object.entries(fishlist.reduce((result, item) => (result[item] = (result[item] || 0) + 1, result), {})).map(([type, count]) => ({ type: parseInt(type), count }));
        return mergedArray
      },
      fishOdd(game_id,fish_id) {
        return fish_utils.read_odd(game_id,fish_id);
      },
      getGameRes(value,is_value,on_value,two_value) {
        if(value === is_value){
           return on_value
        }
        return two_value;
      },
      matchDeepColor(index) {
        return this.mapIndex.some(item => item === index)
      },
      matchDeepPos(index) {
        return index >= 2;
      },
      matchDeepColorList(key, index) {
        return this.mapIndex[key].some(item => item === index)
      },
      matchDeepColorTwo(index) {
        return this.mapIndexTwo.some(item => item === index)
      },
      matchDeppFreeColor(index, freeId) {
        var trigFree = false
        let s = new slots_utils();
        trigFree = s.showSlotsFreeBlock(freeId, this.mapList, 3)

        if (trigFree) {
          return this.mapList[index] === freeId
        } else {
          return false
        }
      },
      matchSubDeppColor(index, subIndex) {
        return this.subMapIndex[index].some(item => item === subIndex)
      },
      matchSubDeppFreeColor(index, subIndex, freeId) {
        var trigFree = false
        let s = new slots_utils();
        trigFree = s.showSlotsFreeBlock(freeId, this.subMapList[index], 3)

        if (trigFree) {
          return this.subMapList[index][subIndex] === freeId
        } else {
          return false
        }
      },
      // getFQZSWinType(index) {
      //   var fq = "飞禽";
      //   var zs = "走兽";
      //   var sy = "鲨鱼";
      //   var ly = "乐园";
      //   if(this.getlang != 'zh_cn') {
      //     fq = "飛禽";
      //     zs = "走獸";
      //     sy = "鯊魚";
      //     ly = "樂園";
      //   }
      //
      //   switch(index) {
      //     case 0:
      //      return zs;
      //     case 1:
      //      return fq;
      //     case 2:
      //      return fq;
      //     case 3:
      //      return fq;
      //     case 4:
      //      return fq;
      //     case 5:
      //      return sy;
      //     case 6:
      //      return zs;
      //     case 7:
      //      return zs;
      //     case 8:
      //      return zs;
      //     case 9:
      //      return zs;
      //     case 10:
      //      return fq;
      //     case 11:
      //      return fq;
      //     case 12:
      //      return ly;
      //     case 13:
      //      return fq;
      //     case 14:
      //      return fq;
      //     case 15:
      //      return zs;
      //     case 16:
      //      return zs;
      //     case 17:
      //      return zs;
      //     case 18:
      //      return zs;
      //     case 19:
      //      return sy;
      //     case 20:
      //      return fq;
      //     case 21:
      //      return fq;
      //     case 22:
      //      return fq;
      //     case 23:
      //      return fq;
      //     case 24:
      //      return zs;
      //     case 25:
      //      return zs;
      //     case 26:
      //      return ly;
      //     case 27:
      //      return zs;
      //   }
      // },
      // getFQZSWinPos(index) {
      //   switch(index) {
      //     case 0:
      //      return 7;
      //     case 1:
      //      return 6;
      //     case 2:
      //      return 5;
      //     case 3:
      //      return 4;
      //     case 4:
      //      return 3;
      //     case 5:
      //      return 11;
      //     case 6:
      //      return 7;
      //     case 7:
      //      return 8;
      //     case 8:
      //      return 9;
      //     case 9:
      //      return 10;
      //     case 10:
      //      return 6;
      //     case 11:
      //      return 5;
      //     case 12:
      //       if(this.getlang != 'zh_cn') {
      //         return "乐园"
      //       } else {
      //         return "樂園"
      //       };
      //     case 13:
      //      return 4;
      //     case 14:
      //      return 3;
      //     case 15:
      //      return 10;
      //     case 16:
      //      return 9;
      //     case 17:
      //      return 8;
      //     case 18:
      //      return 7;
      //     case 19:
      //      return 12;
      //     case 20:
      //      return 3;
      //     case 21:
      //      return 4;
      //     case 22:
      //      return 5;
      //     case 23:
      //      return 6;
      //     case 24:
      //      return 10;
      //     case 25:
      //      return 9;
      //     case 26:
      //       if(this.getlang != 'zh_cn') {
      //         return "乐园"
      //       } else {
      //         return "樂園"
      //       };
      //     case 27:
      //      return 8;
      //   }
      // },
      // getSlwhIcon(index) {
      //   if(index <= 3) {
      //     if(this.getlang != 'zh_cn') {
      //       return "zxh_" + index + "_tw"
      //     } else {
      //       return "zxh_" + index
      //     }
      //   } else {
      //     return Math.floor((index - 1) / 3);
      //   }
      // },
      // getSlwhBg(index) {
      //   if(index <= 3) {
      //     return "czxh"
      //   } else {
      //     return "c" + (Math.floor((index - 1) % 3) + 1);
      //   }
      // },
      // getarrlength() {
      //
      // },
      showCustomName(gameid, merchantName) {
        let c = new comp_name_utils();
        return c.showGameName(gameid, merchantName);
      },
      getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const qwer = data.filter((item) => {
          return item.DeathFishs != null
        })

        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = qwer.map(item => Number(item[column.property]))

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {

              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });

        const hits = data.filter((item) => {
          return item.DeathFishs == null
        })
        const hitssums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            hitssums[index] = '合计';
            return;
          }
          const values = hits.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            hitssums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            hitssums[index] += '';
          } else {
            hitssums[index] = '';
          }
        });
        sums[1] = parseFloat((
          parseInt(isNaN(sums[1]) || (sums[1] == '') ? "0" : sums[1]) +
          parseInt(isNaN(hitssums[1]) || (hitssums[1] == '') ? "0" : hitssums[1])
        ) / 100).toFixed(2)
        sums[2] = parseFloat((
          parseInt(isNaN(sums[2]) || (sums[2] == '') ? "0" : sums[2]) +
          parseInt(isNaN(hitssums[2]) || (hitssums[2] == '') ? "0" : hitssums[2])
        ) / 100).toFixed(2)
        sums[3] = ''

        return sums;
      },
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex % 2 === 0) {
          if (columnIndex === 0) {
            return [1, 2];
          } else if (columnIndex === 1) {
            return [0, 0];
          }
        }
      },
      getDetailBySign() {
        axios.post(http.url + '/game/v1/getDetailBySign', {
          "sign": this.agentId
        }).then(response => {
          if (response.data.code != 200) {
            this.error = response.data.error
          }
          const data = response.data.data
          console.log("getDetailBySign", data)
          if (data) {
            this.recordId = data.recordId
            this.agentName = data.agentName
            this.merchantName = data.merchantName
            this.detailData = data.detail;
          }
          else
          {
              this.detailData = null;
          }
          if (this.gameType == 1)
          {
            detail_by_token.readDataValue(this,data)
          }
          else if (this.gameType == 2)
          {
            this.fish = true
            const data = response.data.data
            this.res_data = data;
            if (response.data.code != 200)
            {
               this.error = response.data.error
            }
            detail_by_token_fish.readDataValue(this,data)

          }
          else if (this.gameType == 6)
          {
            detail_by_token_joker.readDataValue(this,data)
          }
          else if (this.gameType == 5)
          {
            detail_by_token_rocket.readDataValue(this,data)
          }
          else if (this.gameType == 7)
          {
            detail_by_token_esports.readDataValue(this,data)
          }

        })
      },
      getDetailByTokenFish() {
        axios.post(http.url + '/game/v1/getDetailByToken', {
          'token': this.userToken,
          'recordId': this.recordId,
          'gameType': this.gameType,
          'timestamp': this.timestamp
        }).then(response => {
          if (response.data.code != 200) {
            this.error = response.data.error
          }
          const data = response.data.data
          console.log("getDetailByTokenFish", data)
          if (data) {
              this.agentName = data.agentName
              this.merchantName = data.merchantName
              this.detailData = data.detail;
          }
          else
          {
              this.detailData = null;
          }
           detail_by_token_fish.readDataValue(this,data);
        })
      },
      checkLineWin_3 (index_1, index_2, index_3) {
        return (this.mapList[index_1] == this.mapList[index_2] || (this.mapList[index_1] == "W") || (this.mapList[index_2] == "W"))
          && (this.mapList[index_2] == this.mapList[index_3] || (this.mapList[index_2] == "W") || (this.mapList[index_3] == "W"))
          && (this.mapList[index_3] == this.mapList[index_1] || (this.mapList[index_3] == "W") || (this.mapList[index_1] == "W"))
      },
      getDetailByToken() {
        axios.post(http.url + '/game/v1/getDetailByToken', {
          'token': this.userToken,
          'recordId': this.recordId,
          'gameType': this.gameType,
          'timestamp': this.timestamp
        }).then(response => {
          if (response.data.code != 200) {
            this.error = response.data.error
          }
          const data = response.data.data
          console.log("getDetailByToken", data)

          if (data) {
            this.agentName = data.agentName
            this.merchantName = data.merchantName
          }
          if (response.status === 200)
          {
            detail_by_token.readDataValue(this,data)
          }
        })
      },
      getDetailByTokenJoker() {
        axios.post(http.url + '/game/v1/getDetailByToken', {
          'token': this.userToken,
          'recordId': this.recordId,
          'gameType': this.gameType,
          'timestamp': this.timestamp
        }).then(response => {
          if (response.data.code != 200) {
            this.error = response.data.error
          }
          const data = response.data.data
          console.log("getDetailByTokenJoker", data)

          if (data) {
            this.agentName = data.agentName
            this.merchantName = data.merchantName
            this.detailData = data.detail;
          }else
          {
              this.detailData = null;
          }

          if (response.status == 200) {
            if (data)
            {
              detail_by_token_joker.readDataValue(this,data)
            }
          }
        })
      },
      getDetailByTokenrocket() {
        axios.post(http.url + '/game/v1/getDetailByToken', {
          'token': this.userToken,
          'recordId': this.recordId,
          'gameType': this.gameType,
          'timestamp': this.timestamp
        }).then(response => {
          if (response.data.code != 200)
          {
            this.error = response.data.error
          }
          const data = response.data.data
          console.log("getDetailByTokenrocket", data)

          if (data) {
            this.agentName = data.agentName
            this.merchantName = data.merchantName
            this.detailData = data.detail;
          }
          else
          {
             this.detailData = null;
          }
          if (response.status == 200)
          {
            if (data)
            {
              detail_by_token_rocket.readDataValue(this,data)
            }
          }
        })
      },
      timeFormat(Time) {
        //日期格式化
        var time = new Date(parseInt(Time))
        var year = time.getFullYear()
        var month = time.getMonth() + 1
        var date = time.getDate()
        var hours = time.getHours()
        var minutes = time.getMinutes()
        var seconds = time.getSeconds()

        function add0(m) {
          return m < 10 ? '0' + m : m
        }
        var startTime = add0(year) + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) +
          ':' + add0(seconds)
        return startTime
      },
      // 获取浏览器参数 所有连接
      GetRequest() {
        let geturl = window.location.href
        let getqyinfo = geturl.split('?')[1]
        let getqys = getqyinfo.split('&')
        let obj = {} //创建空对象，接收截取的参数
        for (let i = 0; i < getqys.length; i++) {
          let item = getqys[i].split('=')
          let key = item[0]
          let value = item[1]
          obj[key] = value
        }
        return obj

      },
      clearLines() {
        const divs = document.getElementsByClassName("line");
        if (divs) {
          for(var i = 0; i < divs.length; i++) {
            document.body.removeChild(divs[i])
          }
        }
      },
      drawLines(from, to, type) {
        // console.log("drawLines", from, to)
        const fromDiv = document.getElementById(from);
        const toDiv = document.getElementById(to);

        const fromCenterPoints = () => {
          const rect = fromDiv.getBoundingClientRect();
          return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2 + (type * 5)
          };
        }
        const toCenterPoints = () => {
          const rect = toDiv.getBoundingClientRect();
          return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2 + (type * 5)
          };
        }

        // 绘制折线，可以根据需要使用SVG、CSS伪元素等方式
        // 这里以创建一个<div>元素作为折线的示例
        const line = document.createElement('div');
        line.classList.add('line');
        // document.body.appendChild(line);

        var color = "";
        switch(type % 10) {
          case 1:
            color = "red";
            break;
          case 2:
            color = "green";
            break;
          case 3:
            color = "blue";
            break;
          case 4:
            color = "yellow";
            break;
          case 5:
            color = "purple";
            break;
          case 6:
            color = "orange";
            break;
          case 7:
            color = "cyan";
            break;
          case 8:
            color = "pink";
            break;
          case 9:
            color = "brown";
            break;
          case 10:
            color = "gray";
            break;
        }

        line.style.position = 'absolute';
        line.style.zIndex = '999';
        line.style.borderTop = '4px solid ' + color;

        const start = fromCenterPoints();
        const end = toCenterPoints();
        const length = Math.sqrt((end.x - start.x) ** 2 + (end.y - start.y) ** 2) + 4;
        const angle = Math.atan2(end.y - start.y, end.x - start.x) * 180 / Math.PI;

        line.style.width = length + 'px';
        line.style.left = start.x + 'px';
        line.style.top = start.y + 'px';
        line.style.transformOrigin = 'left top';
        line.style.transform = `rotate(${angle}deg)`;
        //line = line.cloneNode(true);
        document.body.appendChild(line);
      }

    }
  }

</script>
<style  lang="scss">
@import '../scss/Detail.scss';
</style>




// WEBPACK FOOTER //
// src/components/gameDetail.vue